import { useState } from "react";
import { OnboardingGalleryPhotoItem } from "./onboarding_timeline_gallery";
import { Grid, TextField } from "@material-ui/core";

export interface OnboardingTimelineGalleryRowProps {
  item: OnboardingGalleryPhotoItem;
  width?: string;
  height?: string;
  onChange: (item: OnboardingGalleryPhotoItem) => void;
}

export function OnboardingTimelineGalleryRow(
  props: OnboardingTimelineGalleryRowProps
) {
  const { item } = props;
  const [url] = useState(item.photo.url);
  const [index, setIndex] = useState(item.index);

  console.log(`index ${index} for ${url}`);
  const onChangeIndexHandler = (value: string) => {
    const v = Number.parseInt(value);
    if (isNaN(v)) return;
    setIndex(v);
    props.onChange({
      photo: {
        url: url,
      },
      index: v,
    });
  };

  return (
    <Grid item xs={12} md={4} lg={3}>
      <img
        src={url}
        style={{
          width: props.width ?? "100%",
          height: props.height ?? "200px",
        }}
        alt="Visibile solo dopo aver salvato"
      />
      <TextField
        type="number"
        label="Ordine"
        variant="outlined"
        value={index}
        onChange={(e) => onChangeIndexHandler(e.target.value)}
        style={{ width: "100%" }}
      ></TextField>
    </Grid>
  );
}
